module.exports = __webpack_public_path__ + "img/login-img.ab655da6.png";